module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.3dafefc5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Bold.woff2
// module id = 3549
// module chunks = 70